export const config = {
    URL:'https://komis.rafalmatras.com/api/'
};